<template>
  <div class="OfferCardHorizontalContent">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'OfferCardHorizontalContent',
}
</script>

<style lang="scss">
.OfferCardHorizontalContent,
.OfferCardHorizontalContent * {
  box-sizing: border-box;
}
.OfferCardHorizontalContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  position: relative;
  overflow: hidden;
}
</style>
